/** Contrato DelivAI — plano e pagamento PIX/boleto — PT / EN / ES */
export const contractTranslations = {
  pt: {
    'contract_plan.title': 'Contrato DelivAI',
    'contract_plan.subtitle': 'Escolha quantos dias deseja contratar e pague via PIX.',
    'contract_plan.mock_banner':
      'Modo simulação ativo (REACT_APP_SANTANDER_PIX_MOCK=true): o QR será de teste até o webhook n8n + Santander estiver pronto.',
    'contract_plan.days_label': 'Dias de contrato ({min} a {max})',
    'contract_plan.preset_days': '{count} dias',
    'contract_plan.cnpj_label': 'CNPJ da empresa',
    'contract_plan.cnpj_optional': '(opcional)',
    'contract_plan.cnpj_placeholder': 'Apenas para identificar no pagamento',
    'contract_plan.reference_label': 'Referência na tela',
    'contract_plan.total_hint':
      '({days} dia(s) × {daily}/dia — valor efetivo vem da cobrança gerada pelo Santander)',
    'contract_plan.continue_button': 'Continuar para pagamento PIX',
    'contract_plan.footer_hint':
      'Ao continuar você será levado para a página com QR Code ou código copia e cola PIX.',

    'contract_pix.back': 'Voltar',
    'contract_pix.title_pix': 'Pague com PIX',
    'contract_pix.title_boleto': 'Pagamento por boleto',
    'contract_pix.contract_days_hint':
      'Contrato referente a {days} dia(s) — o acréscimo na licença ocorre após confirmação pelo financeiro/backend.',
    'contract_pix.boleto_notice':
      'Boleto: os dias contratados só serão acrescidos à sua licença após a compensação do boleto. O webhook do banco deve avisar o n8n para então atualizar dias_restantes.',
    'contract_pix.mock_banner':
      'Simulação: configure o webhook e desative REACT_APP_SANTANDER_PIX_MOCK.',
    'contract_pix.loading_pix': 'Gerando cobrança PIX…',
    'contract_pix.loading_boleto': 'Gerando boleto…',
    'contract_pix.error_pix': 'Não foi possível gerar o PIX.',
    'contract_pix.error_boleto': 'Não foi possível gerar o boleto.',
    'contract_pix.reference': 'Referência: {txid}',
    'contract_pix.expires': 'Vencimento / expiração: {date}',
    'contract_pix.qr_alt': 'QR Code para pagamento PIX',
    'contract_pix.no_qr':
      'Nenhuma imagem nem código EMV para o QR. Peça ao n8n pixCopiaECola ou qrCodeBase64.',
    'contract_pix.copy_label': 'PIX copia e cola',
    'contract_pix.copy_button': 'Copiar código PIX',
    'contract_pix.copy_pix_label': 'PIX',
    'contract_pix.no_pix_response': 'Resposta sem código PIX — ajuste o workflow n8n.',
    'contract_pix.linha_label': 'Linha digitável',
    'contract_pix.copy_linha_button': 'Copiar linha digitável',
    'contract_pix.copy_linha_label': 'Linha digitável',
    'contract_pix.no_linha':
      'Cobrança sem linha digitável na resposta. O n8n deve devolver linhaDigitavel ou linha_digitavel (e opcionalmente boletoUrlPdf).',
    'contract_pix.open_pdf': 'Abrir PDF do boleto',
  },
  en: {
    'contract_plan.title': 'DelivAI Contract',
    'contract_plan.subtitle': 'Choose how many days to purchase and pay via PIX.',
    'contract_plan.mock_banner':
      'Simulation mode active (REACT_APP_SANTANDER_PIX_MOCK=true): QR will be a test until n8n + Santander webhook is ready.',
    'contract_plan.days_label': 'Contract days ({min} to {max})',
    'contract_plan.preset_days': '{count} days',
    'contract_plan.cnpj_label': 'Company CNPJ',
    'contract_plan.cnpj_optional': '(optional)',
    'contract_plan.cnpj_placeholder': 'Only to identify the payment',
    'contract_plan.reference_label': 'On-screen reference',
    'contract_plan.total_hint':
      '({days} day(s) × {daily}/day — effective amount comes from Santander charge)',
    'contract_plan.continue_button': 'Continue to PIX payment',
    'contract_plan.footer_hint':
      'You will be taken to the page with QR Code or PIX copy-and-paste code.',

    'contract_pix.back': 'Back',
    'contract_pix.title_pix': 'Pay with PIX',
    'contract_pix.title_boleto': 'Bank slip payment',
    'contract_pix.contract_days_hint':
      'Contract for {days} day(s) — license extension occurs after finance/backend confirmation.',
    'contract_pix.boleto_notice':
      'Bank slip: contracted days are added to your license only after clearance. The bank webhook must notify n8n to update dias_restantes.',
    'contract_pix.mock_banner':
      'Simulation: configure the webhook and disable REACT_APP_SANTANDER_PIX_MOCK.',
    'contract_pix.loading_pix': 'Generating PIX charge…',
    'contract_pix.loading_boleto': 'Generating bank slip…',
    'contract_pix.error_pix': 'Could not generate PIX.',
    'contract_pix.error_boleto': 'Could not generate bank slip.',
    'contract_pix.reference': 'Reference: {txid}',
    'contract_pix.expires': 'Due / expiration: {date}',
    'contract_pix.qr_alt': 'QR Code for PIX payment',
    'contract_pix.no_qr':
      'No image or EMV code for QR. Ask n8n for pixCopiaECola or qrCodeBase64.',
    'contract_pix.copy_label': 'PIX copy and paste',
    'contract_pix.copy_button': 'Copy PIX code',
    'contract_pix.copy_pix_label': 'PIX',
    'contract_pix.no_pix_response': 'Response without PIX code — adjust n8n workflow.',
    'contract_pix.linha_label': 'Digitable line',
    'contract_pix.copy_linha_button': 'Copy digitable line',
    'contract_pix.copy_linha_label': 'Digitable line',
    'contract_pix.no_linha':
      'Charge without digitable line in response. n8n must return linhaDigitavel or linha_digitavel (and optionally boletoUrlPdf).',
    'contract_pix.open_pdf': 'Open bank slip PDF',
  },
  es: {
    'contract_plan.title': 'Contrato DelivAI',
    'contract_plan.subtitle': 'Elija cuántos días desea contratar y pague vía PIX.',
    'contract_plan.mock_banner':
      'Modo simulación activo (REACT_APP_SANTANDER_PIX_MOCK=true): el QR será de prueba hasta que el webhook n8n + Santander esté listo.',
    'contract_plan.days_label': 'Días de contrato ({min} a {max})',
    'contract_plan.preset_days': '{count} días',
    'contract_plan.cnpj_label': 'CNPJ de la empresa',
    'contract_plan.cnpj_optional': '(opcional)',
    'contract_plan.cnpj_placeholder': 'Solo para identificar el pago',
    'contract_plan.reference_label': 'Referencia en pantalla',
    'contract_plan.total_hint':
      '({days} día(s) × {daily}/día — el valor efectivo viene del cobro generado por Santander)',
    'contract_plan.continue_button': 'Continuar al pago PIX',
    'contract_plan.footer_hint':
      'Será llevado a la página con código QR o código PIX copiar y pegar.',

    'contract_pix.back': 'Volver',
    'contract_pix.title_pix': 'Pague con PIX',
    'contract_pix.title_boleto': 'Pago por boleto',
    'contract_pix.contract_days_hint':
      'Contrato referente a {days} día(s) — la extensión de licencia ocurre tras confirmación del finance/backend.',
    'contract_pix.boleto_notice':
      'Boleto: los días contratados solo se añadirán a su licencia tras la compensación. El webhook del banco debe avisar a n8n para actualizar dias_restantes.',
    'contract_pix.mock_banner':
      'Simulación: configure el webhook y desactive REACT_APP_SANTANDER_PIX_MOCK.',
    'contract_pix.loading_pix': 'Generando cobro PIX…',
    'contract_pix.loading_boleto': 'Generando boleto…',
    'contract_pix.error_pix': 'No se pudo generar el PIX.',
    'contract_pix.error_boleto': 'No se pudo generar el boleto.',
    'contract_pix.reference': 'Referencia: {txid}',
    'contract_pix.expires': 'Vencimiento / expiración: {date}',
    'contract_pix.qr_alt': 'Código QR para pago PIX',
    'contract_pix.no_qr':
      'Sin imagen ni código EMV para el QR. Pida a n8n pixCopiaECola o qrCodeBase64.',
    'contract_pix.copy_label': 'PIX copiar y pegar',
    'contract_pix.copy_button': 'Copiar código PIX',
    'contract_pix.copy_pix_label': 'PIX',
    'contract_pix.no_pix_response': 'Respuesta sin código PIX — ajuste el workflow n8n.',
    'contract_pix.linha_label': 'Línea digitável',
    'contract_pix.copy_linha_button': 'Copiar línea digitável',
    'contract_pix.copy_linha_label': 'Línea digitável',
    'contract_pix.no_linha':
      'Cobro sin línea digitável en la respuesta. n8n debe devolver linhaDigitavel o linha_digitavel (y opcionalmente boletoUrlPdf).',
    'contract_pix.open_pdf': 'Abrir PDF del boleto',
  },
} as const;
